var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 4h-8A1.333 1.333 0 004 5.333v8a1.333 1.333 0 001.333 1.334h8a1.333 1.333 0 001.334-1.334v-8A1.333 1.333 0 0013.333 4zM12 12H6.667V6.667H12V12zm6.667 2.667h8A1.333 1.333 0 0028 13.333v-8A1.334 1.334 0 0026.667 4h-8a1.333 1.333 0 00-1.334 1.333v8a1.333 1.333 0 001.334 1.334zm1.333-8h5.333V12H20V6.667zm-16 20A1.333 1.333 0 005.333 28h8a1.333 1.333 0 001.334-1.333v-8a1.333 1.333 0 00-1.334-1.334h-8A1.333 1.333 0 004 18.667v8zM6.667 20H12v5.333H6.667V20zm10.666 6.667A1.333 1.333 0 0018.667 28h8A1.334 1.334 0 0028 26.667v-8a1.333 1.333 0 00-1.333-1.334h-8a1.333 1.333 0 00-1.334 1.334v8zM20 20h5.333v5.333H20V20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.60c89bca.svg";
export { ForwardRef as ReactComponent };